export const trustPages = [
  {
    slug: "security",
    icon: "ShieldCheck",
    seoTitle: "Aliwer Security Practices & Controls | Trust Center",
    seoDescription:
      "How Aliwer protects data: encryption, access control, secure infrastructure, and operational security practices.",
    title: "Security Practices & Controls",
    intro:
      "As a cybersecurity firm, we hold our own systems to the standards we recommend to clients. This page summarizes our security practices.",
    sections: [
      {
        heading: "Encryption",
        body: "Data is encrypted in transit with TLS. Account passwords are hashed with bcrypt, and sessions use signed, short-lived tokens.",
      },
      {
        heading: "Access control",
        body: "Role-based access separates client, partner, and admin functions. BArecord and its admin console run on fully isolated authentication realms.",
      },
      {
        heading: "Secure infrastructure",
        body: "Services run on managed cloud infrastructure with network isolation, least-privilege access, and regular patching.",
      },
      {
        heading: "Data minimization",
        body: "We collect only what is needed to deliver the service, and retain it only as long as necessary.",
      },
    ],
    cta: { label: "Report a vulnerability", to: "/trust/vulnerability-disclosure" },
  },
  {
    slug: "privacy",
    icon: "Lock",
    seoTitle: "Aliwer Privacy & Data Protection | Trust Center",
    seoDescription:
      "How Aliwer handles personal data, your privacy rights under GDPR and CCPA, and where to read the full policy.",
    title: "Privacy & Data Protection",
    intro:
      "We are committed to protecting personal data and honoring privacy rights. This summarizes our approach; the full policy has complete detail.",
    sections: [
      {
        heading: "What we collect",
        body: "Account details, consultation bookings, partner applications, contact submissions, and limited technical/log data needed to operate securely.",
      },
      {
        heading: "Your rights",
        body: "Depending on your location (GDPR, CCPA/CPRA, Texas Data Privacy and Security Act), you may access, correct, delete, or port your data and opt out of sale or sharing. Aliwer does not sell your personal information.",
      },
      {
        heading: "Data processing",
        body: "Business customers can request a Data Processing Addendum (DPA) for the BArecord and SecureDesk products.",
      },
    ],
    cta: { label: "Read the full Privacy Policy", to: "/privacy" },
  },
  {
    slug: "ai",
    icon: "Cpu",
    seoTitle: "Aliwer AI Governance & Security | Trust Center",
    seoDescription:
      "How Aliwer governs AI use in BArecord and SecureDesk: data handling, model risk, human oversight, and responsible AI principles.",
    title: "AI Governance & Security",
    intro:
      "Our AI products, BArecord and SecureDesk, use third-party AI models. We apply governance and controls so AI is used responsibly.",
    sections: [
      {
        heading: "Data handling",
        body: "Content you submit is processed to provide risk scoring, summaries, monitoring, and responses. You are responsible for having the right to submit such content.",
      },
      {
        heading: "Human oversight",
        body: "AI outputs may contain errors and are provided for informational purposes. They are not legal, compliance, or security determinations and should be independently verified.",
      },
      {
        heading: "Governance",
        body: "We maintain acceptable-use guidelines and controls for AI data access, and provide a DPA for business customers on request.",
      },
    ],
  },
  {
    slug: "compliance",
    icon: "ClipboardCheck",
    seoTitle: "Aliwer Compliance & Security Frameworks | Trust Center",
    seoDescription:
      "The security and compliance frameworks Aliwer aligns to, including SOC 2, ISO 27001, HIPAA, and GDPR, with transparent status.",
    title: "Compliance & Security Frameworks",
    intro:
      "Our controls are designed to align with recognized frameworks. Certification status is shown transparently and updated as we progress.",
    sections: [
      { heading: "SOC 2", body: "Certification in progress." },
      { heading: "ISO 27001", body: "Certification in progress." },
      { heading: "HIPAA", body: "Advisory and controls support for covered entities and business associates." },
      { heading: "GDPR / CCPA", body: "Privacy program in place; DPA available for business customers." },
    ],
    note: "[Placeholder] Replace with links to audit reports or certificates once available.",
  },
  {
    slug: "subprocessors",
    icon: "Server",
    seoTitle: "Aliwer Subprocessors & Data Processing | Trust Center",
    seoDescription:
      "The categories of third-party subprocessors Aliwer uses to operate its services and process customer data.",
    title: "Subprocessors & Data Processing",
    intro:
      "We use trusted third-party providers to operate the service. They process data only on our instructions and under appropriate contractual safeguards.",
    sections: [
      { heading: "Cloud hosting & database", body: "Managed cloud infrastructure and database hosting for the application and its data." },
      { heading: "Transactional email", body: "Delivery of booking, application, and notification emails." },
      { heading: "AI processing", body: "Third-party AI models that power BArecord and SecureDesk features." },
    ],
    note: "A current, itemized list of subprocessors is available to customers on request.",
  },
  {
    slug: "vulnerability-disclosure",
    icon: "AlertTriangle",
    seoTitle: "Aliwer Vulnerability Disclosure Program | Trust Center",
    seoDescription:
      "How to responsibly report a security vulnerability to Aliwer and what to expect from our security team.",
    title: "Vulnerability Disclosure Program",
    intro:
      "If you believe you've found a security vulnerability, we want to hear from you. Please report it privately so we can investigate and fix it.",
    sections: [
      { heading: "How to report", body: "Email aliwer.usa@gmail.com with the subject 'Security Disclosure' and include steps to reproduce, impact, and any supporting evidence." },
      { heading: "What to expect", body: "We will acknowledge your report, investigate promptly, and keep you informed of progress and resolution." },
      { heading: "Please", body: "Do not publicly disclose an issue until we have resolved it, and avoid actions that could harm users or data during testing." },
    ],
    cta: { label: "Email the security team", to: "mailto:aliwer.usa@gmail.com?subject=Security%20Disclosure" },
    note: "Machine-readable policy: /.well-known/security.txt",
  },
];
